<div *ngIf="learningTour" class="learning-map-wrap" [ngClass]="{'isShowEnterAnimate':isShowEnterAnimate}" id="learningWrap-out">
  <div class="{{themeBG}}" style="overflow: hidden;">
    <!-- <div class="logo" *ngIf="companyMetaId===248"><img src="{{assetsRoute}}/picture/learningmap/HP.png" /></div> -->
    <!-- <div class="specialLogo" *ngIf="companyMetaId==391"><img src="{{assetsRoute}}/picture/learningmap/YF.png" /></div> -->
    <div class="secret-door" (click)="showVersion()"></div>
    <div class="title fontSize24 lineHeight34" *ngIf="!customizeMetaInfo.logoUrl && !customizeMetaInfo.companyName && companyMetaId!==248&&companyMetaId!==391">
      <span class="text" *ngIf="themeBG==='company'">英跃学堂</span>
      <span *ngIf="themeBG==='open'">公开课</span>
      <span *ngIf="themeBG==='experience'">体验课</span>
    </div>
    <div class="vertical-layout" *ngIf="customizeMetaInfo.companyName || customizeMetaInfo.logoUrl">
      <div class="top-item" [ngStyle]="{width:verticalLogoSize[0]+'px',height:verticalLogoSize[1]+'px'}">
        <img [ngStyle]="{width:customizeMetaInfo.width+'px',height:customizeMetaInfo.height+'px'}" src="{{customizeMetaInfo.logoUrl}}" alt="">
      </div>
      <div class="bottom-item lineHeight34 fontSize24">
        <span [innerHtml]="customizeMetaInfo.companyName || '英跃学堂'"></span>
      </div>
    </div>
<!--    <div class="specialTitle fontSize24 lineHeight34" *ngIf="companyMetaId===248">FY21 Fast Start</div>-->
    <div class="learningWrap">

      <!-- 训练营 -->
      <!-- <div class="learning-camp" *ngFor="let item of campList;let i= index;">
        <p class="name">{{item['projectName']}}</p>
        <p class="desc">{{item['description']}}</p>
        <div class="button" (click)="goCampList(item['projectId'],item['campMetasId'])">点击开启<img style="display:inline-block;width: .15rem;margin-left: .1rem" src="{{assetsRoute}}/picture/camp/i-right-light.png" /></div>
        <div class="img" [ngStyle]="{'background-image': 'url(assets/picture/camp/'+item['campMetasId']+'.png)' }" ></div>
      </div> -->
      <!-- 项目列表 -->
      <div *ngIf="learningTour.projectList">
        <div class="learning-project" *ngFor="let item of learningTour['projectList'];let i= index;">
          <div class="learnProject-list">
            <p class="name">{{ item['projectName'] }}</p>
            <p class="desc" *ngIf="!(item['totalCourseNum'] === 0 && item['totalHomeworkNum'] !== 0)">共{{ item['allCouseNum'] }}门课程，已完成{{ item['totalProgress'] }}%</p>
            <p class="desc" *ngIf="item['totalCourseNum'] === 0 && item['totalHomeworkNum'] !== 0">已完成{{ item['totalProgress'] }}%</p>
            <div *ngIf="item.isOnlyCampCourse">
              <!-- 只有一门训练营课程 -->
              <div *ngIf="!item.campMetasList[0].isExpiry && item.campMetasList[0].isOpen" class="button" (click)="goProjectList(item)">进入学习<img style="display:inline-block;width: .15rem;margin-left: .1rem" src="{{assetsRoute}}/picture/camp/i-right-light.png" /></div>
              <div *ngIf="!item.campMetasList[0].isExpiry && !item.campMetasList[0].isOpen" class="data-lock">{{ item.campMetasList[0].campOpenTime }}开放</div>
              <div *ngIf="item.campMetasList[0].isExpiry" class="data-lock">已过期</div>
            </div>
            <div *ngIf="!item.isOnlyCampCourse" class="button" (click)="goProjectList(item)">进入学习<img style="display:inline-block;width: .15rem;margin-left: .1rem" src="{{assetsRoute}}/picture/camp/i-right-light.png" /></div>

          </div>
          <div class="img" [ngStyle]="{'background-image': 'url(assets/picture/project/projectImg.png)' }" ></div>
        </div>
      </div>
      <!-- 课程列表 -->
      <div [ngClass]="{'learning-Item':true,profeshional:item.profeshional}" (click)="goLearnPath(item.id, item.abilityVersion, item.name)" *ngFor="let item of learningTour.learning_path_metas;let i= index;">
        <div *ngIf="item.abilityVersion === '在线课' || item.abilityVersion === '微课'" class="pinpoint-course-image" [ngStyle]="{'background-image': 'url(' + setPinpointPicture(item.id) + '.jpg)'}"></div>
        <div class="img" *ngIf="item.abilityVersion === '酷领导'" [ngStyle]="{'background-image': 'url(assets/picture/learningmap/newicon/scorm-' + { '卓越辅导': 1, '超效沟通': 2, '巅峰绩效对话': 3, '活化变革': 4, '建立超卓团队': 5, '开启领导力之门': 6, '任务规划与执行': 7, '效率决策': 8, '致胜表达': 9}[item.series] +  '.png)' }" ></div>
        <div class="img" *ngIf="item.abilityVersion !== '在线课' && item.abilityVersion !== '微课' && item.abilityVersion !== '酷领导'" [ngStyle]="{'background-image': 'url(assets/picture/learningmap/newicon/' + item.id + '.png)' }" ></div>
        <div class="item-title"><span class="version-tag" *ngIf="item.abilityVersion === '英跃微课'">视频课程</span>{{item.name}}</div>
        <div class="description" *ngIf="item.abilityVersion === '酷领导'">课程系列：{{item.series}}</div>
        <div class="description" *ngIf="item.abilityVersion !== '酷领导'">{{item.description}}</div>
        <component-progress-bar [isPC]="isPC" [theme]="circleTheme" [type]="'circle'" [progress]="item['progress']" ></component-progress-bar>
  <!--      <div class="finishBtn" *ngIf="item.finished || (item.id == 22 && finishSpecialFlag)">已完成</div>-->
        <div class="arrow">&gt;</div>
      </div>
    </div>
  </div>
</div>
<app-break-point *ngIf="haveBreakPoint && !isVisitorToolsGuide &&!isWxWork" [userBreakPoint]="userBreakPoint" [assetsRoute]="assetsRoute" (closeAppBreakPoint)="closeAppBreakPoint()" ></app-break-point>





// WEBPACK FOOTER //
// ./src/app/learning-map/learning-map.component.html